import { History, MessageSquare } from 'lucide-react'
import { useGeneralAgentChatStore } from '../hooks/generalAgentChatStore'
import { GeneralAgentHeaderButton } from './GeneralAgentHeaderButton'

/** Switches between the conversation and the list of past chats. */
export const GeneralAgentHistoryButton = () => {
    const view = useGeneralAgentChatStore((s) => s.view)
    const setView = useGeneralAgentChatStore((s) => s.setView)
    const inHistory = view === 'history'

    return (
        <GeneralAgentHeaderButton label={inHistory ? 'Back to chat' : 'Chat history'} onClick={() => setView(inHistory ? 'chat' : 'history')}>
            {inHistory ? <MessageSquare className="h-4 w-4" /> : <History className="h-4 w-4" />}
        </GeneralAgentHeaderButton>
    )
}
